module.exports = __webpack_public_path__ + "img/bg.1ec712b7.webp";